import { zeroAddress } from 'viem'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const BINANCECHAIN = {
  name: 'bsc',
  chainId: 56,
  averageBlockTimeSeconds: 3,
  explorerUrl: 'https://bscscan.com/',
  nativeAsset: {
    assetAddress: zeroAddress,
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  slip44: 714,
  wrappedNativeAsset: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  blockscoutApiUrl: undefined,
  etherscanSupported: true,
  publicRpcUrls: ['https://bsc.nodereal.io', 'https://bsc-dataseed.ninicoin.io'],
  getPrivateRpcUrls: () => {
    const bsc: string[] = []
    process.env.ROUTEME_API_KEY && bsc.push(`https://lb.routeme.sh/rpc/56/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('bsc')
    quickNodeUrl && bsc.push(quickNodeUrl)
    process.env.ALCHEMY_API_KEY && bsc.push(`https://bnb-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    process.env.INFURA_API_KEY && bsc.push(`https://bsc-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    return bsc
  },
} as const satisfies ChainConfig
